import Image from 'next/image';
import { useEffect, useState } from 'react';
import { PiWallet } from 'react-icons/pi';
import { Button } from '../ui/button';
import { CreditCard } from 'lucide-react';
import { TbBrandCoinbase } from 'react-icons/tb';
import { SiApplepay } from 'react-icons/si';
import { SlPaypal } from 'react-icons/sl';
import { CiBank } from 'react-icons/ci';
import { useDetectPlatform } from '@/hooks/utilities/useDetectPlatform';
import { FaGooglePay } from 'react-icons/fa';
import useGetLocation from '@/hooks/utilities/useGetLocation';
import { Toggle } from '../ui/toggle';
import { Switch } from '../ui/switch';
export default function PaymentOptions({
  setSelectWallet,
  setSelectedPaymentMethod
}) {
  const platform = useDetectPlatform();
  const {
    useOnRamper,
    setUseOnRamper,
    geoState
  } = useGetLocation();
  return <div className='ta-l mt-4 ' data-sentry-component="PaymentOptions" data-sentry-source-file="PaymentOptions.tsx">
      {platform == 'ios' && <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between   p-0 pb-0 mb-0`}>
          <div className='flex flex-col items-start justify-between w-full '>
            <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('apple')} className='flex justify-between w-full px-0'>
              <div className='flex items-center justify-start text-[16px]'>
                <SiApplepay className='w-[22px] h-[22px] mr-2' />
                Apple Pay
              </div>
              <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
                {useOnRamper ? 'via Stripe' : 'via Moonpay'}
              </p>
            </Button>
          </div>
        </div>}
      {platform == 'android' && <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between   p-0 pb-0 mb-0`}>
          <div className='flex flex-col items-start justify-between w-full '>
            <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('google')} className='flex justify-between w-full px-0'>
              <div className='flex items-center justify-start text-[16px]'>
                <FaGooglePay className='w-[22px] h-[22px] mr-2' />
                Google Pay
              </div>
              <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
                {useOnRamper ? 'via Stripe' : 'via Moonpay'}
              </p>
            </Button>
          </div>
        </div>}

      <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between   p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}>
        <div className='flex flex-col items-start justify-between w-full '>
          <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('card')} className='flex justify-between w-full px-0' data-sentry-element="Button" data-sentry-source-file="PaymentOptions.tsx">
            <div className='flex items-center justify-start text-[16px]'>
              <CreditCard className='w-[22px] h-[22px] mr-2 ' data-sentry-element="CreditCard" data-sentry-source-file="PaymentOptions.tsx" />
              Credit | Debit
            </div>
            <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
              {useOnRamper ? 'via Stripe' : 'via Moonpay'}
              <br />
            </p>
          </Button>

          {/* {showNY && (
            <div className='my-4 text-left mt- text-genius-cream/50 tracking-tighter '>
              <span className='text-genius-cream text-md block mt-6 mb-4'>No ❤️ for NYC</span>
              <span className='text-xs block text-genius-cream/50'>
                Due to regulation, paying with your debit card via Moonpay is not supported in New
                York State. We know, it sucks. If you already have a
                <span className='text-genius-cream  inline mx-1'>
                  Coinbase Account or Crypto Wallet,
                </span>
                we would recommend funding your Genius account only through that.
              </span>
              <Button
                size='sm'
                variant='ghost'
                type='button'
                onClick={() => setShowNY(false)}
                className='bg-black rounded-full w-fit p-2 px-4 mx-auto  text-genius-cream text-xs mt-4 block cursor-pointer'
              >
                Got it
              </Button>
            </div>
           )} */}
        </div>
      </div>
      {/* Paypal */}
      {/* <div
        style={{
          paddingBottom: '0px',
          paddingLeft: '16px',
          paddingRight: '16px',
          paddingTop: '0px',
        }}
        className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}
       >
        <div className='flex flex-col items-start justify-between w-full '>
          <Button
            variant='ghost'
            type='button'
            onClick={() => setSelectedPaymentMethod(null)}
            className='flex justify-between w-full px-0'
          >
            <div className='flex items-center justify-start text-[16px]'>
              <SlPaypal className='w-[22px] h-[22px] mr-2' />
              Paypal <span className='text-[10px] bg-genius-blue rounded-full px-2 ml-4'>Soon</span>
            </div>
            <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
              {useOnRamper
                ? onlyAllowStripe
                  ? 'via Stripe'
                  : 'via OnRamper'
                : 'via Moonpay'}
            </p>
          </Button>
        </div>
       </div> */}
      <div style={{
      paddingBottom: '0px',
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '0px'
    }} className={`min-h-[54px] h-fit  flex items-center text-genius-cream text-[16px] justify-between p-0 pb-0 mb-0 hover:bg-genius-blue rounded-md cursor-pointer`}>
        <div className='flex flex-col items-start justify-between w-full '>
          <Button variant='ghost' type='button' onClick={() => setSelectedPaymentMethod('bank')} className='flex justify-between w-full px-0' data-sentry-element="Button" data-sentry-source-file="PaymentOptions.tsx">
            <div className='flex items-center justify-start text-[16px]'>
              <CiBank className='w-[22px] h-[22px] mr-2' data-sentry-element="CiBank" data-sentry-source-file="PaymentOptions.tsx" />
              Bank Account
            </div>
            <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
              {useOnRamper ? 'via Stripe' : 'via Moonpay'}
            </p>
          </Button>
        </div>
      </div>
      <div className='flex justify-end items-center px-4 text-xs '>
        {' '}
        {geoState != 'NY' && <Button variant='purple' onClick={() => setUseOnRamper(!useOnRamper)} className='flex mt-2  items-center px-4 text-xs rounded-md  '>
            Switch to {useOnRamper ? 'Moonpay' : 'Stripe'}
          </Button>}
      </div>
      <div onClick={() => setSelectedPaymentMethod('coinbase')} className='h-[54px] flex items-center justify-between px-4 text-genius-cream text-[16px] hover:bg-genius-blue rounded-md cursor-pointer'>
        <div className='flex items-center '>
          {' '}
          <TbBrandCoinbase className='w-[22px] h-[22px] mr-2' data-sentry-element="TbBrandCoinbase" data-sentry-source-file="PaymentOptions.tsx" />
          Coinbase{' '}
        </div>

        <p className='text-genius-cream/50 ml-2 ta-r text-[16px] justify-end'>
          Crypto or Debit
          <br />
          {/* <span className='w-full text-[10px] '>Available in NYC</span> */}
        </p>
      </div>
      <div onClick={() => {
      setSelectWallet(true);
      setSelectedPaymentMethod('evm');
    }} className='h-[54px] flex items-center text-genius-cream text-[16px] px-4 hover:bg-genius-blue rounded-md cursor-pointer'>
        <PiWallet className='w-[22px] h-[22px] mr-2' data-sentry-element="PiWallet" data-sentry-source-file="PaymentOptions.tsx" />
        Crypto Wallet
      </div>
    </div>;
}